import React from 'react';
import CardGroup from '../CardGroup/CardGroup';
import { useLaunchedSubCategories } from '../../hooks/useLaunchedSubCategories';
import styles from './LaunchedSubCategories.module.css';

const LaunchedSubCategories = ({
  componentSize = "Desktop 1440",
  selectedCategoryId = 9,
  onCardSelect
}) => {
  const {
    cardGroups,
    containerWidth,
    isLoading,
    error,
    isEmpty
  } = useLaunchedSubCategories({
    componentSize,
    selectedCategoryId
  });

  if (error) {
    console.error('Error loading launched subcategories:', error);
    return null;
  }

  if (isLoading) {
    return null;
  }

  if (isEmpty) {
    return null;
  }

  return (
    <div
      className={styles.cardGroupsContainer}
      style={{ width: containerWidth }}
    >
      {cardGroups.map((group, groupIndex) => (
        <CardGroup
          key={groupIndex}
          size={componentSize}
          cardId1={group[0]?.id || ""}
          cardId2={group[1]?.id || ""}
          cardId3={group[2]?.id || ""}
          cardId4={group[3]?.id || ""}
          cardId5={group[4]?.id || ""}
          groupPick12={(groupIndex % 12) + 1}
          groupPick7={(groupIndex % 7) + 1}
          cardCount={group.length}
          onCardSelect={onCardSelect}
        />
      ))}
    </div>
  );
};

export default LaunchedSubCategories;